import {Mapper} from '@s-ui/domain'

export default class FromAdvertisingValueObjectToAdvertisingPageDataValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Function} param.advertisingPageDataValueObjectFactory
   */
  constructor({advertisingPageDataValueObjectFactory, config}) {
    super()

    this._pageConfig = config.get('page')
    this._advertisingPageDataValueObjectFactory = advertisingPageDataValueObjectFactory
  }

  /**
   * Set url to be used when mapping.
   * @param {{url: string}} setUrl
   */
  setUrl({url}) {
    this._url = url

    return this
  }

  /**
   * @param {import('../ValueObjects/AdvertisingValueObject').default} advertisingVO
   * @returns {import('../ValueObjects/AdvertisingPageDataValueObject').default}
   */
  map(advertisingVO) {
    const segmentation = advertisingVO.toJSON()

    return this._advertisingPageDataValueObjectFactory({
      url: this._url,
      page_name: segmentation.ads_name_page,
      segmentation
    })
  }
}
